import { render, staticRenderFns } from "./DeleteInfo.vue?vue&type=template&id=9b0479f6&scoped=true"
import script from "./DeleteInfo.vue?vue&type=script&lang=js"
export * from "./DeleteInfo.vue?vue&type=script&lang=js"
import style0 from "./DeleteInfo.vue?vue&type=style&index=0&id=9b0479f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0479f6",
  null
  
)

export default component.exports